var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "content package-student-page package-student-page--packages",
    },
    [
      _c(
        "section",
        {
          ref: "pageHero",
          staticClass: "ps-hero",
          class: { "is-hidden": _vm.isHeroHidden },
        },
        [
          _vm._m(0),
          _c(
            "div",
            { staticClass: "ps-hero__actions" },
            [
              _c(
                "el-button",
                {
                  attrs: { plain: "", icon: "el-icon-school" },
                  on: {
                    click: function ($event) {
                      return _vm.$router.push(
                        "/package-student/school-packages"
                      )
                    },
                  },
                },
                [_vm._v("\n            Áp dụng gói cho trường\n          ")]
              ),
            ],
            1
          ),
        ]
      ),
      _c("div", { staticClass: "ps-overview-sticky" }, [
        _c(
          "div",
          {
            ref: "statsGrid",
            staticClass: "ps-stat-grid-package",
            style: _vm.statsStyle,
          },
          [
            _c("div", { staticClass: "ps-stat-card" }, [
              _vm._m(1),
              _c("div", [
                _c("span", { staticClass: "ps-stat-card__value" }, [
                  _vm._v(_vm._s(_vm.packageTotal)),
                ]),
                _c("span", { staticClass: "ps-stat-card__label" }, [
                  _vm._v("Tổng số gói"),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "ps-stat-card ps-stat-card--green" }, [
              _vm._m(2),
              _c("div", [
                _c("span", { staticClass: "ps-stat-card__value" }, [
                  _vm._v(_vm._s(_vm.activeCount)),
                ]),
                _c("span", { staticClass: "ps-stat-card__label" }, [
                  _vm._v("Đang sử dụng"),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "ps-stat-card ps-stat-card--orange" }, [
              _vm._m(3),
              _c("div", [
                _c("span", { staticClass: "ps-stat-card__value" }, [
                  _vm._v(_vm._s(_vm.inactiveCount)),
                ]),
                _c("span", { staticClass: "ps-stat-card__label" }, [
                  _vm._v("Ngưng sử dụng"),
                ]),
              ]),
            ]),
          ]
        ),
      ]),
      _c(
        "section",
        { staticClass: "ps-card ps-card--list", style: _vm.cardLayoutStyle },
        [
          _c("div", { ref: "cardTop", staticClass: "ps-card__top" }, [
            _c(
              "div",
              { staticClass: "ps-card__heading" },
              [
                _vm._m(4),
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "primary",
                      size: "small",
                      icon: "el-icon-plus",
                    },
                    on: { click: _vm.openCreateDialog },
                  },
                  [_vm._v("\n          Thêm gói\n        ")]
                ),
              ],
              1
            ),
            _c("div", { staticClass: "ps-toolbar" }, [
              _c(
                "div",
                { staticClass: "ps-toolbar__left" },
                [
                  _c(
                    "el-form",
                    {
                      staticClass: "ps-toolbar__filters",
                      attrs: { inline: "", "label-position": "top" },
                      nativeOn: {
                        submit: function ($event) {
                          $event.preventDefault()
                        },
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Tìm theo mã / tên gói" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "220px" },
                            attrs: {
                              size: "small",
                              clearable: "",
                              "prefix-icon": "el-icon-search",
                              placeholder: "Nhập mã hoặc tên gói",
                            },
                            model: {
                              value: _vm.search,
                              callback: function ($$v) {
                                _vm.search = $$v
                              },
                              expression: "search",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Trạng thái gói" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "145px" },
                              attrs: { size: "small" },
                              model: {
                                value: _vm.activeFilter,
                                callback: function ($$v) {
                                  _vm.activeFilter = $$v
                                },
                                expression: "activeFilter",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "Tất cả", value: "all" },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: "Đang sử dụng",
                                  value: "active",
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: "Ngưng sử dụng",
                                  value: "inactive",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.hasActiveFilters
                        ? _c(
                            "el-button",
                            {
                              staticClass: "ps-filter-reset",
                              attrs: {
                                type: "text",
                                icon: "el-icon-refresh-left",
                              },
                              on: { click: _vm.resetFilters },
                            },
                            [_vm._v("\n              Đặt lại\n            ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "ps-toolbar__actions" },
                [
                  _vm.selectedPackages.length
                    ? _c("span", { staticClass: "ps-selected-count" }, [
                        _vm._v(
                          "\n            Đã chọn " +
                            _vm._s(_vm.selectedPackages.length) +
                            " gói\n          "
                        ),
                      ])
                    : _vm._e(),
                  _c(
                    "el-dropdown",
                    {
                      attrs: {
                        trigger: "click",
                        disabled:
                          !_vm.selectedPackages.length || _vm.batchSaving,
                      },
                      on: { command: _vm.handleBulkAction },
                      scopedSlots: _vm._u([
                        {
                          key: "dropdown",
                          fn: function () {
                            return [
                              _c(
                                "el-dropdown-menu",
                                [
                                  _c(
                                    "el-dropdown-item",
                                    {
                                      attrs: {
                                        command: "activate",
                                        icon: "el-icon-video-play",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Kích hoạt gói đã chọn\n                "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "el-dropdown-item",
                                    {
                                      attrs: {
                                        command: "deactivate",
                                        icon: "el-icon-video-pause",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Ngưng sử dụng gói đã chọn\n                "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            size: "small",
                            type: "primary",
                            plain: "",
                            loading: _vm.batchSaving,
                            disabled: !_vm.selectedPackages.length,
                          },
                        },
                        [
                          _vm._v("\n              Tác vụ "),
                          _c("i", {
                            staticClass: "el-icon-arrow-down el-icon--right",
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "ps-card__table" },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  ref: "packageTable",
                  staticClass: "sk-table ps-table",
                  attrs: {
                    data: _vm.paginatedPackages,
                    border: "",
                    stripe: "",
                    "max-height": 760,
                    "empty-text": "Chưa có gói giới hạn nào",
                  },
                  on: { "selection-change": _vm.handleSelectionChange },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      type: "selection",
                      width: "52",
                      align: "center",
                      fixed: "left",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "STT",
                      type: "index",
                      width: "58",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Mã gói",
                      prop: "code",
                      "min-width": "150",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c("span", { staticClass: "ps-package-code" }, [
                              _vm._v(_vm._s(row.code)),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Tên gói",
                      prop: "name",
                      "min-width": "220",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c("span", { staticClass: "ps-package-name" }, [
                              _vm._v(_vm._s(row.name)),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Số giới hạn",
                      prop: "limit",
                      width: "150",
                      align: "right",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c("span", { staticClass: "ps-limit-value" }, [
                              _vm._v(
                                _vm._s(_vm._f("formatNumber")(row.limit)) +
                                  " HS"
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Ngày tạo",
                      prop: "createdAt",
                      width: "145",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _vm._v(_vm._s(_vm._f("formatDate")(row.createdAt))),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Trạng thái",
                      width: "145",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: row.active ? "success" : "info",
                                  size: "small",
                                  effect: "light",
                                },
                              },
                              [
                                _c("i", {
                                  class: row.active
                                    ? "el-icon-circle-check"
                                    : "el-icon-remove-outline",
                                }),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      row.active
                                        ? "Đang sử dụng"
                                        : "Ngưng sử dụng"
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Thao tác",
                      width: "160",
                      align: "center",
                      fixed: "right",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "div",
                              { staticClass: "ps-action-row" },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      content: "Chỉnh sửa gói",
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c("el-button", {
                                      attrs: {
                                        type: "primary",
                                        plain: "",
                                        circle: "",
                                        size: "mini",
                                        icon: "el-icon-edit",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openEditDialog(row)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      content: row.active
                                        ? "Ngưng sử dụng"
                                        : "Kích hoạt lại",
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c("el-button", {
                                      attrs: {
                                        type: row.active
                                          ? "warning"
                                          : "success",
                                        plain: "",
                                        circle: "",
                                        size: "mini",
                                        icon: row.active
                                          ? "el-icon-video-pause"
                                          : "el-icon-video-play",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleActive(row)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "ps-pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  small: "",
                  background: "",
                  layout: "total, sizes, prev, pager, next",
                  "current-page": _vm.currentPage,
                  "page-size": _vm.pageSize,
                  "page-sizes": [5, 10, 20],
                  total: _vm.packageTotal,
                },
                on: {
                  "current-change": _vm.handlePageChange,
                  "size-change": _vm.handlePageSizeChange,
                },
              }),
            ],
            1
          ),
        ]
      ),
      _c("PackageFormDialog", {
        attrs: {
          visible: _vm.dialogVisible,
          "editing-package": _vm.editingPackage,
          saving: _vm.saving,
        },
        on: {
          "update:visible": function ($event) {
            _vm.dialogVisible = $event
          },
          submit: _vm.handleSavePackage,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "ps-hero__main" }, [
      _c("div", { staticClass: "ps-hero__icon" }, [
        _c("i", { staticClass: "el-icon-collection-tag" }),
      ]),
      _c("div", [
        _c("h1", [_vm._v("Quản lý gói giới hạn học sinh")]),
        _c("p", [
          _vm._v(
            "Tạo và quản lý các gói giới hạn số lượng học sinh áp dụng cho từng trường trong hệ thống."
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "ps-stat-card__icon" }, [
      _c("i", { staticClass: "el-icon-collection-tag" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "ps-stat-card__icon" }, [
      _c("i", { staticClass: "el-icon-circle-check" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "ps-stat-card__icon" }, [
      _c("i", { staticClass: "el-icon-warning-outline" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "ps-card__heading-left" }, [
      _c("div", { staticClass: "ps-card__heading-icon" }, [
        _c("i", { staticClass: "el-icon-box" }),
      ]),
      _c("div", [
        _c("h2", [_vm._v("Danh sách gói giới hạn")]),
        _c("p", [
          _vm._v(
            "Mã gói không thể chỉnh sửa sau khi tạo để đảm bảo tính duy nhất."
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }